export default __webpack_public_path__ + "static/image3-917e5a8881d3b0d741a413fd16fadfbc.jpg";